module.exports = __webpack_public_path__ + "img/IMG_8986.7fea22e4.jpg";